import { defineDocument } from '../../schema';
export const blogGoingLiveDecemberStreamerUpdatesDocument = defineDocument({
    id: 'blog:going-live-december-streamer-updates',
    kind: 'blog',
    slug: 'going-live-december-streamer-updates',
    route: '/blog/going-live-december-streamer-updates',
    seo: {
        title: 'Going Live: December Streamer Updates',
        description: 'Going Live detection, new mod tools, and quality-of-life upgrades built for streamers',
        imageAsset: 'twitchLive',
    },
    hero: {
        eyebrow: [
            {
                type: 'text',
                text: 'Airhead Blog',
            },
        ],
        title: [
            {
                type: 'text',
                text: 'Going Live: December Streamer Updates',
            },
        ],
        description: [
            {
                type: 'text',
                text: 'Going Live detection, new mod tools, and quality-of-life upgrades built for streamers',
            },
        ],
        imageAsset: 'twitchLive',
        imageAlt: 'Image of computer with LIVE on the screen',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2025-12-08T00:00:00.000Z'),
        tags: ['features'],
    },
    sections: [
        {
            id: 'article',
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'More visibility. More control. More of what streamers want! We shipped ',
                        },
                        {
                            type: 'link',
                            href: '/discover/features/twitch#going-live',
                            children: [
                                {
                                    type: 'text',
                                    text: 'Going Live detection',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: ', added new mod tools, and delivered a whole bunch of improvements for streamers.',
                        },
                    ],
                },
            ],
            sections: [
                {
                    id: 'article__twitch-x-airhead-games-going-live-detection',
                    title: [
                        {
                            type: 'text',
                            text: 'Twitch x Airhead Games: Going Live Detection',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Our goal is to help more viewers discover your stream and jump into your games. When you meet these conditions:',
                                },
                            ],
                        },
                        {
                            type: 'list',
                            items: [
                                [
                                    {
                                        type: 'text',
                                        text: 'Your Twitch account is linked to your Airhead Games user profile',
                                    },
                                ],
                                [
                                    {
                                        type: 'text',
                                        text: 'You are streaming live on Twitch',
                                    },
                                ],
                                [
                                    {
                                        type: 'text',
                                        text: 'You open a new game room for any of our party games',
                                    },
                                ],
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'You will be displayed as LIVE across all landing pages of our website and we will post to the ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: '#going-live',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' channel in our ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://discord.gg/rfFTVAqHwH',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Discord',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' community.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__say-what',
                    title: [
                        {
                            type: 'text',
                            text: 'Say What?',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'You can now set ',
                                },
                                {
                                    type: 'link',
                                    href: '/discover/features/audio#audio-experience__volume-controls',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'custom volume defaults',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ', so every room starts (and resets) to your preferred mix. It is a small change that makes a big difference when you are balancing game audio, voice, and music on stream.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__updates-polish',
                    title: [
                        {
                            type: 'text',
                            text: 'Updates & Polish',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'We added a ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Skip Intro',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' button to every game so returning players can jump straight into the action.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Game-specific improvements:',
                                },
                            ],
                        },
                        {
                            type: 'list',
                            items: [
                                [
                                    {
                                        type: 'link',
                                        href: '/discover/games/wtf-is-happening',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'WTF Is Happening',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ': clearer section banner and better headline card layout.',
                                    },
                                ],
                                [
                                    {
                                        type: 'link',
                                        href: '/discover/games/ego-maniacs',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'Ego Maniacs',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ': faster trophy image generation, fewer award-generation hiccups, and two new songs.',
                                    },
                                ],
                                [
                                    {
                                        type: 'link',
                                        href: '/discover/games/finish-each-others-sandwiches',
                                        children: [
                                            {
                                                type: 'text',
                                                text: "Finish Each Other's Sandwiches",
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ': lower weirdness factor in rounds 1 and 3 for more coherent prompts.',
                                    },
                                ],
                                [
                                    {
                                        type: 'link',
                                        href: '/discover/games/second-opinions',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'Second Opinions',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ': fixed a sound effect bug.',
                                    },
                                ],
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'We also made several quality-of-life improvements. Visit ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: '#whats-poppin',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' in our ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://discord.gg/rfFTVAqHwH',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Discord',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' community to see the full release notes.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'If you are streaming, this is just the beginning. Link your Twitch account, go live, and let us know what streamer tools you want next.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__hit-the-airwaves',
                    title: [
                        {
                            type: 'text',
                            text: 'Hit The Airwaves',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'link',
                                    href: '/login',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Log in with Twitch now',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '.',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'article-actions',
            widgets: [
                {
                    type: 'relatedDocuments',
                    limit: 4,
                },
            ],
        },
    ],
});
//# sourceMappingURL=going-live-december-streamer-updates.js.map